export const legalConfig = {
  controllerName:
    process.env.NEXT_PUBLIC_LEGAL_CONTROLLER_NAME || 'YOKAMOTRIL S.L.',
  controllerAddress:
    process.env.NEXT_PUBLIC_LEGAL_CONTROLLER_ADDRESS ||
    'Pol. Ind. el Vadillo, Carretera Almeria, 49, 18600 Motril, Granada',
  controllerEmail:
    process.env.NEXT_PUBLIC_LEGAL_CONTROLLER_EMAIL || 'pablo.rodriguez@yokamotril.com',
  controllerId: process.env.NEXT_PUBLIC_LEGAL_CONTROLLER_ID || 'B18321802',
  providerName: process.env.NEXT_PUBLIC_LEGAL_PROVIDER_NAME || 'rpidev',
  providerUrl: process.env.NEXT_PUBLIC_LEGAL_PROVIDER_URL || 'https://rpidev.com',
  lastUpdated: process.env.NEXT_PUBLIC_LEGAL_LAST_UPDATED || '2026-03-03',
};
